/**
 * Detalle de pedido: un pedido puede quedar sin ítems (dato huérfano de
 * seed o carga incompleta). Mostrar "0 ítems / Productos $0" junto a un
 * total real miente — la UI avisa "sin ítems cargados" y oculta la fila
 * Productos del desglose.
 */
export type OrderItemsVisibility = {
  hasItems: boolean;
  /** Aviso explícito en la sección de productos cuando no hay ítems. */
  showEmptyWarning: boolean;
  /** Fila "Productos" del desglose de dinero. */
  showProductsRow: boolean;
};

export function resolveOrderItemsVisibility(
  items: readonly unknown[] | null | undefined,
): OrderItemsVisibility {
  const hasItems = (items?.length ?? 0) > 0;
  return {
    hasItems,
    showEmptyWarning: !hasItems,
    showProductsRow: hasItems,
  };
}
